import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {GraphService} from "../../shared/services/graph.service";
import {CookieService} from "ngx-cookie-service";
import {GraphVariableModel} from "../../shared/models/graph-variable.model";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-graph-type',
  templateUrl: './graph-type.component.html',
  styleUrls: ['./graph-type.component.scss']
})
export class GraphTypeComponent implements OnInit, OnDestroy {
  @Input() componentContext: 'graph-page' | 'dataset-page';
  graphType: string;
  graphVariablesSubscription: Subscription;
  graphVariables: GraphVariableModel[];

  constructor(
    private graphService: GraphService
  ) {
  }

  ngOnInit(): void {
    const graphTypeKey = this.graphService.getGraphTypeKey(this.componentContext);
    const iolrGraphType = this.graphService.getLocalStorageSelectedVariables(graphTypeKey);
    // getLocalStorageSelectedVariables() already JSON.parses; do not parse again (crashes on reload).
    const graphType = iolrGraphType.length > 0 ? iolrGraphType : null;
    this.graphType = graphType ? graphType : 'line';
    this.loadGraphVariables();
    this.subscribeToGraphVariables();
  }

  loadGraphVariables(): void {
    const selectedVariablesKey = this.graphService.getSelectedVariablesKey(this.componentContext);
    this.graphVariables = this.graphService.getLocalStorageSelectedVariables(selectedVariablesKey);
  }

  subscribeToGraphVariables(): void {
    this.graphVariablesSubscription = this.graphService.graphVariablesSubject.subscribe(graphVariables => {
      this.graphVariables = graphVariables;
    })
  }

  onSelectGraphType(): void {
    const graphTypeKey = this.graphService.getGraphTypeKey(this.componentContext);
    this.graphService.setLocalStorageSelectedVariables(graphTypeKey, this.graphType);
    this.graphService.graphTypeSubject.next(this.graphType);
  }

  ngOnDestroy(): void {
    if (this.graphVariablesSubscription) {
      this.graphVariablesSubscription.unsubscribe();
    }
  }

}
